import { RequestTypes } from '../../../hooks'

export const USER_API_PREFIX = '/api/extension/v1'
export const USER_FIND = '/extension/origin_certificates/unregistered_users/'

export const getFindUsers = {
    link: `${USER_API_PREFIX}${USER_FIND}`,
    method: RequestTypes.get,
}
